import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard } from "lucide-react";
import { usePortal } from "@/context/PortalContext";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Btn } from "@/components/portal/ui";
import { LanguageSwitcher } from "@/components/portal/LanguageSwitcher";
import { NotificationBell } from "@/components/portal/NotificationBell";

export function PortalHeader() {
  const { portalKey, portal } = usePortal();
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 h-16 border-b backdrop-blur-md flex items-center"
      style={{ background: "color-mix(in srgb, var(--surface) 88%, transparent)", borderColor: "var(--border)" }}
      data-testid="portal-header"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 flex items-center gap-4">
        <Link to={`/p/${portalKey}/dashboard`} className="font-heading text-2xl font-bold tracking-tight" style={{ color: "var(--text)" }} data-testid="portal-logo">
          {portal?.name}
        </Link>
        <nav className="ml-auto flex items-center gap-2 sm:gap-3">
          <Link to="/select" className="hidden sm:inline-flex items-center text-sm font-medium px-3 py-2" style={{ color: "var(--text-muted)" }} data-testid="nav-switch-portal">
            {t("nav.switchPortal")}
          </Link>
          <LanguageSwitcher />
          {user ? (
            <>
              <NotificationBell />
              <Btn variant="soft" onClick={() => navigate(`/p/${portalKey}/dashboard`)} data-testid="nav-dashboard" className="h-10">
                <LayoutDashboard className="h-4 w-4" /> <span className="hidden sm:inline">{t("nav.dashboard")}</span>
              </Btn>
              <Btn variant="ghost" onClick={logout} data-testid="nav-logout" className="h-10 px-3">
                <LogOut className="h-4 w-4" />
              </Btn>
            </>
          ) : (
            <Btn onClick={() => navigate(`/p/${portalKey}/auth`)} data-testid="nav-login" className="h-10">
              {t("nav.login")}
            </Btn>
          )}
        </nav>
      </div>
    </header>
  );
}
